var $ = require('jquery');

module.exports = {
	init: function() {
		$('a.story__seeMore').each(function(){
			var $this = $(this),
				$extendedContent = $this.parent().find('.story__extendedContent');
			$this.data('opened', false);
			$this.on('click', function(){
				if ( $this.data('opened') == false ) {
					$extendedContent.slideDown(400, 'easeOutCirc');
					$this.html('See less');
					$this.toggleClass('story__seeMore--open');
					$this.data('opened', true);
				} else {
					$extendedContent.slideUp(600, 'easeInBack');
					$this.html('See more');
					$this.toggleClass('story__seeMore--open');
					$this.data('opened', false);
				}
				return false;
			});

		});
	}
};
